
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import createIndexedDBStorage from 'redux-persist-indexeddb-storage';
import authReducer from './slice/authSlice';
import bulkUploadSlice from './slice/bulkUploadSlice';
import globalDataSlice from './slice/globalData';
import chatSlice from './slice/chatSlice';

const storage = createIndexedDBStorage({
  name: 'myAppDB',       
  storeName: 'persistedStore', 
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'bulkUploadData', 'chat'], 
};

const rootReducer = combineReducers({
  auth: authReducer,
  bulkUploadData: bulkUploadSlice,
  globalDataSlice,
  chat:chatSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER], 
      },
    }),
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };
